import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { UrlService } from "src/app/services/url.service";
import { RouterLink } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-information-content",
  templateUrl: "./information-content.component.html",
  imports: [RouterLink, MatIcon, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformationContentComponent {
  title = input.required<string>();
  constructor(public urlService: UrlService) {}
}
